/* ============================================================
   CUSTOM METAL WALLET CARD - FRONT VIEW FABRIC.JS CUSTOMIZER
   Canvas/source image: 1536 x 1024 (custom_metal_wallet_card_background.png)
   Customizable area: the whole front face of the card, with a small
   uniform padding on all four sides (stays clear of the rounded
   corners). Three independent text pieces - Title / Message /
   Signature - each with its OWN font choice, so a customer can build
   a "Dear Husband..." style card; plus one optional decorative
   image/logo upload.
============================================================ */

function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}

var cWidth = 1536;
var cHeight = 1024;
var halfWidth = cWidth / 2;
var halfHeight = cHeight / 2;

var loader = jQuery('#customLoader');
var loadedObject = null;
var wMark = null;
var svgMrk = null;

/*
  Measured directly off custom_metal_wallet_card_background.png
  (1536 x 1024): the full front face, inset just enough to clear the
  rounded corners on all four sides.
*/
var PANEL = {
  left: 227,
  top: 213,
  width: 1094,
  height: 594
};
PANEL.right = PANEL.left + PANEL.width;
PANEL.bottom = PANEL.top + PANEL.height;
PANEL.centerX = PANEL.left + PANEL.width / 2;
PANEL.centerY = PANEL.top + PANEL.height / 2;

function makePanelClipPath() {
  return new fabric.Rect({
    left: PANEL.left,
    top: PANEL.top,
    width: PANEL.width,
    height: PANEL.height,
    absolutePositioned: true,
    rx: 10,
    ry: 10
  });
}

var starimage = document.querySelector('#stars_background');
var starBackground = new fabric.Image(starimage, {
  left: 0,
  top: 0,
  selectable: false,
  evented: false,
  objectCaching: false
});

starBackground.scaleToWidth(cWidth);

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight,
  preserveObjectStacking: true,
  selection: true
});

window['canvas2'].add(starBackground);
starBackground.sendToBack();

showFabricCanvasLoader();
addModify(window['canvas2']);

var canvasInitialRenderDone = false;
function markCanvasReady() {
  if (canvasInitialRenderDone) return;
  canvasInitialRenderDone = true;
  hideFabricCanvasLoader();
}

function clampToPanel(obj) {
  if (!obj || !obj.getCenterPoint) return;

  var margin = 25;
  var minX = PANEL.left - margin;
  var maxX = PANEL.right + margin;
  var minY = PANEL.top - margin;
  var maxY = PANEL.bottom + margin;
  var center = obj.getCenterPoint();

  var x = Math.min(Math.max(center.x, minX), maxX);
  var y = Math.min(Math.max(center.y, minY), maxY);

  if (x !== center.x || y !== center.y) {
    obj.setPositionByOrigin(new fabric.Point(x, y), 'center', 'center');
    obj.setCoords();
  }
}

function restackLayers(canvas) {
  if (starBackground) starBackground.sendToBack();
  if (window.uploadedImageObj) window.uploadedImageObj.bringToFront();
  if (window['text1Page']) window['text1Page'].bringToFront(); // title
  if (window['text2Page']) window['text2Page'].bringToFront(); // message
  if (window['text3Page']) window['text3Page'].bringToFront(); // signature
  if (window['text55Page']) window['text55Page'].bringToFront(); // watermark
  canvas.renderAll();
}

/* ==================================================================
   FORCE-WRAP SAFETY NET
================================================================== */
function forceWrapSafe(text, maxRun) {
  if (!text) return '';
  maxRun = (maxRun && maxRun >= 30) ? maxRun : 30;
  var out = '';
  var runLen = 0;

  for (var i = 0; i < text.length; i++) {
    var ch = text[i];
    out += ch;

    if (ch === ' ' || ch === '\n' || ch === '\t') {
      runLen = 0;
    } else {
      runLen++;
      if (runLen >= maxRun && i < text.length - 1) {
        out += ' ';
        runLen = 0;
      }
    }
  }

  return out;
}

/* ==================================================================
   AUTO-FIT TEXT
================================================================== */
function fitTextToBox(textObj, maxHeight, baseFontSize, minFontSize) {
  if (!textObj || !textObj.text) return;

  if (fabric.charWidthsCache) {
    if (textObj.fontFamily && fabric.charWidthsCache[textObj.fontFamily]) {
      delete fabric.charWidthsCache[textObj.fontFamily];
    } else {
      fabric.charWidthsCache = {};
    }
  }
  if (textObj.fontFamily && fabric.util && fabric.util.clearFabricFontCache) {
    fabric.util.clearFabricFontCache(textObj.fontFamily);
  }

  textObj.set({ scaleX: 1, scaleY: 1 });
  textObj.set('fontSize', baseFontSize);
  if (textObj._clearCache) textObj._clearCache();
  textObj.initDimensions();

  var guard = 0;
  while (textObj.height > maxHeight && textObj.fontSize > minFontSize && guard < 80) {
    textObj.set('fontSize', textObj.fontSize - 1);
    if (textObj._clearCache) textObj._clearCache();
    textObj.initDimensions();
    guard++;
  }

  textObj.setCoords();
}

/* Per-field size zones / budgets within PANEL */
var TITLE_MAX_HEIGHT = PANEL.height * 0.20;
var TITLE_BASE_FONT = 64;
var TITLE_MIN_FONT = 26;

var MESSAGE_MAX_HEIGHT = PANEL.height * 0.52;
var MESSAGE_BASE_FONT = 34;
var MESSAGE_MIN_FONT = 16;

var SIGNATURE_MAX_HEIGHT = PANEL.height * 0.18;
var SIGNATURE_BASE_FONT = 48;
var SIGNATURE_MIN_FONT = 20;

(function () {
  function initCardCustomizer() {
    var canvas2 = window['canvas2'];
    if (!canvas2) return;

    canvas2.on('object:moving', function (e) {
      if (e.target && e.target !== starBackground && e.target !== window['text55Page']) {
        clampToPanel(e.target);
      }
    });

    /* ==========================================================
       1) TITLE - Initialized empty to prevent font race glitch
    ========================================================== */
    window['text1Page'] = new fabric.Textbox('', {
      left: PANEL.left + 25,
      top: PANEL.top + 30,
      originX: 'left',
      originY: 'center',
      width: PANEL.width - 50,
      fontSize: TITLE_BASE_FONT,
      fontFamily: 'Dancing Script',
      fill: '#000000',
      textAlign: 'left',
      editable: false,
      lockUniScaling: true,
      splitByGrapheme: true,
      clipPath: makePanelClipPath(),
      objectCaching: false
    });
    canvas2.add(window['text1Page']);

    /* ==========================================================
       2) MESSAGE - Initialized empty to prevent font race glitch
    ========================================================== */
    window['text2Page'] = new fabric.Textbox('', {
      left: PANEL.centerX,
      top: PANEL.centerY + 5,
      originX: 'center',
      originY: 'center',
      width: PANEL.width * 0.8,
      fontSize: MESSAGE_BASE_FONT,
      fontFamily: 'Poppins',
      fill: '#000000',
      textAlign: 'center',
      lineHeight: 1.25,
      editable: false,
      lockUniScaling: true,
      splitByGrapheme: true,
      clipPath: makePanelClipPath(),
      objectCaching: false
    });
    canvas2.add(window['text2Page']);

    /* ==========================================================
       3) SIGNATURE - Initialized empty to prevent font race glitch
    ========================================================== */
    window['text3Page'] = new fabric.Textbox('', {
      left: PANEL.centerX,
      top: PANEL.bottom - 30,
      originX: 'center',
      originY: 'center',
      width: PANEL.width * 0.75,
      fontSize: SIGNATURE_BASE_FONT,
      fontFamily: 'Dancing Script',
      fill: '#000000',
      textAlign: 'center',
      editable: false,
      lockUniScaling: true,
      splitByGrapheme: true,
      clipPath: makePanelClipPath(),
      objectCaching: false
    });
    canvas2.add(window['text3Page']);

    /* ==========================================================
       BRAND WATERMARK
    ========================================================== */
    window['text55Page'] = new fabric.Text('@tasweer.com.pk', {
      left: cWidth - 145,
      top: cHeight - 35,
      fontSize: 16,
      fontFamily: 'Baloo2',
      fill: '#777',
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false,
      selectable: false,
      evented: false
    });
    canvas2.add(window['text55Page']);
    restackLayers(canvas2);

    /* ==========================================================
       FONT-LOAD & INITIAL POPULATE
    ========================================================== */
    function populateAndFitAllText() {
      var t1 = (document.getElementById('text_1') && document.getElementById('text_1').value) || 'Dear Husband';
      var t2 = (document.getElementById('text_2') && document.getElementById('text_2').value) || 'Everytime you open your wallet, remember someone loves you unconditionally. You make every day brighter and every moment worth it. Thank you for being my strength, my peace, my forever, always and through every chapter of life.';
      var t3 = (document.getElementById('text_3') && document.getElementById('text_3').value) || 'Love, Your Wife';

      if (window['text1Page']) {
        window['text1Page'].set({ text: forceWrapSafe(t1, 14) });
        fitTextToBox(window['text1Page'], TITLE_MAX_HEIGHT, TITLE_BASE_FONT, TITLE_MIN_FONT);
      }
      if (window['text2Page']) {
        window['text2Page'].set({ text: forceWrapSafe(t2, 14) });
        fitTextToBox(window['text2Page'], MESSAGE_MAX_HEIGHT, MESSAGE_BASE_FONT, MESSAGE_MIN_FONT);
      }
      if (window['text3Page']) {
        window['text3Page'].set({ text: forceWrapSafe(t3, 14) });
        fitTextToBox(window['text3Page'], SIGNATURE_MAX_HEIGHT, SIGNATURE_BASE_FONT, SIGNATURE_MIN_FONT);
      }

      restackLayers(canvas2);
      canvas2.renderAll();
      markCanvasReady();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        populateAndFitAllText();
      });
      setTimeout(populateAndFitAllText, 400);
      setTimeout(populateAndFitAllText, 1200);
    } else {
      setTimeout(populateAndFitAllText, 400);
      setTimeout(populateAndFitAllText, 1200);
    }

    jQuery(window).on('load', function () {
      populateAndFitAllText();
    });

    // Pre-select each dropdown to match its text object's starting font.
    jQuery('.choose_font1[data-obj=text1Page]').val("'" + window['text1Page'].fontFamily + "'").trigger('change');
    jQuery('.choose_font1[data-obj=text2Page]').val("'" + window['text2Page'].fontFamily + "'").trigger('change');
    jQuery('.choose_font1[data-obj=text3Page]').val("'" + window['text3Page'].fontFamily + "'").trigger('change');

    /* ---- wire up the three textareas ---- */
    function wireTextField(inputId, fabricObj, placeholderText, maxHeight, baseFontSize, minFontSize) {
      var el = document.getElementById(inputId);
      if (!el) return;

      var wrappedPlaceholder = forceWrapSafe(placeholderText, 14);

//      el.addEventListener('focus', function () {
//   if (
//     fabricObj.text === placeholderText ||
//     fabricObj.text === wrappedPlaceholder ||
//     el.value === placeholderText
//   ) {
//     el.value = '';
//     fabricObj.set('text', '');
//     canvas2.renderAll();
//   }
// });

      el.addEventListener('input', function (e) {
        var lines = e.target.value.split('\n').slice(0, 6);
        e.target.value = lines.join('\n');
        fabricObj.set({ text: forceWrapSafe(e.target.value, 14) });
        fitTextToBox(fabricObj, maxHeight, baseFontSize, minFontSize);
        canvas2.renderAll();
      });
    }

    wireTextField('text_1', window['text1Page'], 'Dear Husband',
      TITLE_MAX_HEIGHT, TITLE_BASE_FONT, TITLE_MIN_FONT);
    wireTextField('text_2', window['text2Page'],
      'Everytime you open your wallet, remember someone loves you unconditionally. You make every day brighter and every moment worth it. Thank you for being my strength, my peace, my forever, always and through every chapter of life.',
      MESSAGE_MAX_HEIGHT, MESSAGE_BASE_FONT, MESSAGE_MIN_FONT);
    wireTextField('text_3', window['text3Page'], 'Love, Your Wife',
      SIGNATURE_MAX_HEIGHT, SIGNATURE_BASE_FONT, SIGNATURE_MIN_FONT);

    /* Each text piece has its OWN font dropdown */
    jQuery(document).on('change', '.fontFamily', function () {
      var value = (jQuery(this).val() || '').replace(/'/g, '');
      var objId = jQuery(this).data('obj');
      if (!objId || !window[objId]) return;

      window[objId].set('fontFamily', value);

      if (objId === 'text1Page') fitTextToBox(window[objId], TITLE_MAX_HEIGHT, TITLE_BASE_FONT, TITLE_MIN_FONT);
      else if (objId === 'text2Page') fitTextToBox(window[objId], MESSAGE_MAX_HEIGHT, MESSAGE_BASE_FONT, MESSAGE_MIN_FONT);
      else if (objId === 'text3Page') fitTextToBox(window[objId], SIGNATURE_MAX_HEIGHT, SIGNATURE_BASE_FONT, SIGNATURE_MIN_FONT);

      canvas2.renderAll();
    });

    /* One shared color applied to all three pieces together. */
    var colorInput = document.getElementById('text_color');
    if (colorInput) {
      colorInput.addEventListener('input', function (e) {
        if (window['text1Page']) window['text1Page'].set('fill', e.target.value);
        if (window['text2Page']) window['text2Page'].set('fill', e.target.value);
        if (window['text3Page']) window['text3Page'].set('fill', e.target.value);
        canvas2.renderAll();
      });
    }

    /* ==========================================================
       OPTIONAL IMAGE / LOGO / DECORATIVE ICON UPLOAD
    ========================================================== */
    var uploadedImageObj = null;
    var imageUpload = document.getElementById('design_image_upload');
    var removeImageBtn = document.getElementById('removeDesignImage');

    if (imageUpload) {
      imageUpload.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        if (!file) return;

        var reader = new FileReader();
        reader.onload = function (evt) {
          fabric.Image.fromURL(evt.target.result, function (img) {
            if (uploadedImageObj) canvas2.remove(uploadedImageObj);

            var maxW = PANEL.width * 0.3;
            var maxH = PANEL.height * 0.3;
            var scale = Math.min(maxW / img.width, maxH / img.height);

            img.set({
              left: PANEL.centerX,
              top: PANEL.top + 70,
              originX: 'center',
              originY: 'center',
              scaleX: scale,
              scaleY: scale,
              selectable: true,
              evented: true,
              lockUniScaling: false,
              clipPath: makePanelClipPath(),
              objectCaching: false
            });

            uploadedImageObj = img;
            window.uploadedImageObj = img;
            canvas2.add(img);
            restackLayers(canvas2);
            canvas2.setActiveObject(img);
            canvas2.renderAll();

            if (removeImageBtn) removeImageBtn.style.display = 'inline-block';
          });
        };
        reader.readAsDataURL(file);
      });
    }

    if (removeImageBtn) {
      removeImageBtn.addEventListener('click', function () {
        if (uploadedImageObj) {
          canvas2.remove(uploadedImageObj);
          uploadedImageObj = null;
          window.uploadedImageObj = null;
        }
        if (imageUpload) imageUpload.value = '';
        removeImageBtn.style.display = 'none';
        canvas2.renderAll();
      });
    }

    /* ==========================================================
       ADD TO CART / EXPORT
    ========================================================== */
    jQuery(document).on('click', '#download', function () {
      loader.removeClass('hidden');
      canvas2.discardActiveObject();
      canvas2.renderAll();

      setTimeout(function () {
        var id = ['canvas2'];
        var canvas = canvas2;
        var size = 406;

        loadMarkAsync(id, canvas, size).then(function () {
          if (loadedObject) {
            canvas.remove(loadedObject);
            loadedObject = null;
          }

                    canvas.setZoom(1);
          canvas.setDimensions({ width: cWidth, height: cHeight });

          // Background aur watermark ko hide kiya taake print file 100% TRANSPARENT PNG bane
          if (starBackground) starBackground.visible = false;
          if (window['text55Page']) window['text55Page'].visible = false;
          canvas.renderAll();

                    // Crop only the customization on pure transparent background
          var cropMultiplier = 4000 / cWidth;
          var sourceCanvasEl = canvas.lowerCanvasEl || canvas.getElement();

          // Mobile retina / high-DPI screens (2x, 3x) scaling fix:
          var scaleX = sourceCanvasEl.width / cWidth;
          var scaleY = sourceCanvasEl.height / cHeight;

          var sx = Math.round(PANEL.left * scaleX);
          var sy = Math.round(PANEL.top * scaleY);
          var sw = Math.round(PANEL.width * scaleX);
          var sh = Math.round(PANEL.height * scaleY);

          var cropCanvasEl = document.createElement('canvas');
          cropCanvasEl.width = Math.round(PANEL.width * cropMultiplier);
          cropCanvasEl.height = Math.round(PANEL.height * cropMultiplier);
          var cropCtx = cropCanvasEl.getContext('2d');
          cropCtx.clearRect(0, 0, cropCanvasEl.width, cropCanvasEl.height);
          cropCtx.drawImage(
            sourceCanvasEl,
            sx, sy, sw, sh,
            0, 0, cropCanvasEl.width, cropCanvasEl.height
          );
          window['canvas2exported'] = cropCanvasEl.toDataURL('image/png');

          console.log('[card] cropped export size (px):', cropCanvasEl.width, 'x', cropCanvasEl.height);

          // Screen display ke liye background wapas show kar diya
          if (starBackground) starBackground.visible = true;
          if (window['text55Page']) window['text55Page'].visible = true;
          canvas.renderAll();

          var titleText = (document.getElementById('text_1') || {}).value || '';
          var messageText = (document.getElementById('text_2') || {}).value || '';
          var signatureText = (document.getElementById('text_3') || {}).value || '';
          var enterText = 'Title: ' + titleText +
            ' | Message: ' + messageText +
            ' | Signature: ' + signatureText;

          var titleFont = window['text1Page'] ? window['text1Page'].fontFamily : '';
          var messageFont = window['text2Page'] ? window['text2Page'].fontFamily : '';
          var signatureFont = window['text3Page'] ? window['text3Page'].fontFamily : '';
          var textFont = 'Title: ' + titleFont + ' | Message: ' + messageFont + ' | Signature: ' + signatureFont;

          var textColor = jQuery('#text_color').val() || '#000000';
          var additionalInfo = jQuery('.tShirtImg textarea').val() || '';

          if (typeof canvasBlock === 'function') canvasBlock(canvas);

          function finishAddToCart(previewId, extraImg1) {
            jQuery('#previewImg').val(previewId || '');
            jQuery('#preExtraImg').val(extraImg1 || '');
            jQuery('#enterText').val(enterText);
            jQuery('#textFont').val(textFont);
            jQuery('#textColor').val(textColor);
            jQuery('#addInfo').val(additionalInfo);

            jQuery('.product-form__buttons .product-form__submit').trigger('click');
            loader.addClass('hidden');
          }

          var cartAddedAlready = false;
          var safetyTimer = setTimeout(function () {
            if (cartAddedAlready) return;
            cartAddedAlready = true;
            finishAddToCart('', '');
          }, 15000);

          fetch('//technology-architects.com/tasweer-modules/save_order.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              temp_image: window['canvas2t'],
              original_image: window['canvas2exported']
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response.text().then(function (text) {
                  throw new Error('save_order.php returned ' + response.status);
                });
              }
              return response.json();
            })
            .then(function (data) {
              clearTimeout(safetyTimer);
              if (cartAddedAlready) return;
              cartAddedAlready = true;

              var previewId = data && data[0] ? data[0] : '';
              var extraImg1 = data && data[1] ? data[1] : '';
              extraImg1 = toAbsoluteUploadUrl(extraImg1);

              finishAddToCart(previewId, extraImg1);
            })
            .catch(function (error) {
              console.error('[card] Error uploading card design:', error);
              clearTimeout(safetyTimer);
              if (cartAddedAlready) return;
              cartAddedAlready = true;
              finishAddToCart('', '');
            });
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardCustomizer);
  } else {
    initCardCustomizer();
  }
})();

/* ============================================================
   RESPONSIVE DISPLAY
============================================================ */
function canvasMakeImg(canvas, zoom) {
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function canvasBlock(canvas) {
  if (!canvas) return;
  var zoom = jQuery('.product__media-outer').width();
  if (!zoom) return;
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function setZoomMask(canvas, newZoomLevel) {
  if (!canvas || !newZoomLevel) return;

  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width: cWidth * newZoomLevel,
    height: cHeight * newZoomLevel
  });
  canvas.renderAll();

  var wrapperEl = canvas.wrapperEl;
  if (wrapperEl) {
    wrapperEl.style.marginLeft = 'auto';
    wrapperEl.style.marginRight = 'auto';
    wrapperEl.style.display = 'block';
  }
}

function addModify(canvas) {
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;
  canvas.renderOnAddRemove = false;

  canvas.on('object:added', function () {
    canvas.renderAll();
  });

  canvas.on('object:modified', function () {
    canvas.renderAll();
  });
}

jQuery(window).on('resize', function () {
  canvasBlock(window['canvas2']);
});

jQuery(window).on('load', function () {
  canvasBlock(window['canvas2']);
});

/* ============================================================
   SITE WATERMARK EXPORT HELPERS
============================================================ */
function loadMark(id, canvas, size) {
  wMark = document.getElementById('wm_collage');
  if (!wMark) {
    canvasMakeImg(canvas, size);
    window[id + 't'] = canvas.toDataURL('image/png');
    return;
  }

  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function (objects, options) {
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false,
      evented: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
    canvasMakeImg(canvas, size);
    window[id + 't'] = canvas.toDataURL('image/png');
  });
}

function loadMarkAsync(id, canvas, size) {
  return new Promise(function (resolve) {
    wMark = document.getElementById('wm_collage');
    if (!wMark) {
      canvasMakeImg(canvas, size);
      window[id + 't'] = canvas.toDataURL('image/png');
      resolve();
      return;
    }

    svgMrk = wMark.innerHTML;
    fabric.loadSVGFromString(svgMrk, function (objects, options) {
      loadedObject = fabric.util.groupSVGElements(objects, options);
      loadedObject.scaleToWidth(cWidth);
      loadedObject.set({
        left: cWidth / 2,
        top: cHeight / 2,
        originX: 'center',
        originY: 'center',
        objectCaching: false,
        selectable: false,
        evented: false
      });
      canvas.add(loadedObject);
      loadedObject.bringToFront();
      loadedObject.setCoords();
      canvas.renderAll();
      canvasMakeImg(canvas, size);
      window[id + 't'] = canvas.toDataURL('image/png');
      resolve();
    });
  });
}

function removeMark(canvas, size) {
  if (loadedObject) {
    canvas.remove(loadedObject);
    loadedObject = null;
  }
  canvasMakeImg(canvas, size);
}

function toAbsoluteUploadUrl(value) {
  if (!value) return '';
  if (/^(https?:)?\/\//i.test(value) || /^data:/i.test(value)) return value;
  var path = value.charAt(0) === '/' ? value : '/tasweer-modules/' + value;
  return '//technology-architects.com' + path;
}